import { FormField, NumberInput } from "@wix/design-system";
import React, { useRef } from "react";
const InputWithLabel = ({ label, value, onChange, min, max, dataHook }) => {
  const inputRef = useRef(null);
  const handleInputWithinBounds = (data) => {
    const numberValue = typeof data === "string" && data.trim() !== "" && !isNaN(Number(data)) ? parseFloat(parseFloat(data).toFixed(2)) : NaN;
    const valueWithinBounds = (isNaN(numberValue) || numberValue < min ? min : numberValue > max ? max : numberValue).toString();
    if (value !== valueWithinBounds) {
      onChange(valueWithinBounds);
      return;
    }
  };
  return /* @__PURE__ */ React.createElement(
    FormField,
    {
      label,
      labelSize: "small",
      labelPlacement: "left",
      labelWidth: "60%",
      inputWidth: "40%"
    },
    /* @__PURE__ */ React.createElement(
      NumberInput,
      {
        inputRef,
        value,
        onChange: (_, stringValue) => {
          onChange(stringValue);
        },
        min,
        max,
        onBlur: (e) => {
          handleInputWithinBounds(e.target.value);
        },
        onKeyDown: (e) => {
          if (e.key === "Enter") {
            handleInputWithinBounds(inputRef.current?.value);
          }
        },
        size: "small",
        dataHook
      }
    )
  );
};
export {
  InputWithLabel
};
//# sourceMappingURL=input-with-label.js.map
